import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgFaqs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.014 20l-1.3-3.9c1.124-1.662 1.53-3.63 1.144-5.538-.386-1.908-1.539-3.627-3.244-4.836-1.704-1.21-3.845-1.828-6.024-1.74-2.179.09-4.247.878-5.821 2.22-1.574 1.342-2.546 3.147-2.735 5.079-.19 1.931.417 3.858 1.706 5.422 1.29 1.564 3.173 2.658 5.302 3.08 2.13.422 4.358.142 6.272-.787l4.7 1M12.14 16v.01",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.8c0-.477.184-.935.512-1.273A1.724 1.724 0 0111.75 8h.5c.463 0 .908.19 1.236.527.328.338.513.796.513 1.273.018.39-.07.776-.25 1.1-.18.325-.443.57-.75.7-.306.173-.498.4-.75.725-.223.29-.268.656-.25 1.175",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgFaqs as ReactComponent };
